import Observable from '../observable';
import MarkerWithLabelFactory from '../markerwithlabel';

const labelClassDetail = 'fitting-label--detail';
const labelClassHover = 'fitting-label--hovered';
const labelClassDetailMps = 'fitting-label-mps--detail';
const labelClassHoverMps = 'fitting-label-mps--hovered';
const truckIcon = TYROOLA.globals.staticUrl + 'images/fitting_station_finder/truck-mobile-fitter.png';

class MapMarker extends Observable {
	constructor(map, latitude, longitude, id, value, stationName, isMobileFitter, isMarketplaceSeller, isMpsProduct, stationData) {

		super();

		this.map            = map;
		this.latitude       = latitude;
		this.longitude      = longitude;
		this.id             = id;
		this.value	        = value;
		this.stationName    = stationName;
		this.isMobileFitter = isMobileFitter;
		this.isMarketplaceSeller = isMarketplaceSeller;
		this.isMpsProduct 	= isMpsProduct;
		this.stationData 	= stationData;

		if (isMarketplaceSeller && isMpsProduct) {
            this.labelClass = 'fitting-label fitting-label-mps fitting-label-' + id;
            this.labelClassSelected = this.labelClass + ' fitting-label-mps-selected';
            this.labelClassDetail = this.labelClass + ' fitting-label-mps-detail';
            this.labelClassHovered = this.labelClass + ' fitting-label-mps--hovered';
        } else {
			this.labelClass = 'fitting-label fitting-label-' + id;
            this.labelClassSelected = this.labelClass + ' fitting-label-selected';
            this.labelClassDetail = this.labelClass + ' fitting-label-detail';
            this.labelClassHovered = this.labelClass + ' fitting-label--hovered';
        }

		this.labelStyle = stationData.sponsored && stationData.primaryColor && stationData.secondaryColor
			? `background-color: ${stationData.primaryColor}; color: ${stationData.secondaryColor}`
			: '';

		this.icons     = {
			'initial'   : 'https://maps.gstatic.com/mapfiles/transparent.png',
			'fallback'   : TYROOLA.globals.staticUrl + 'images/fitting-pin-black.png'
		};

		this.location  = null;
		this.markerWithLabel = null;
	}

	init() {

		if (!this.loadDependenices()) {
			throw new Error('Google maps is has not loaded.');
		}

		this.markerWithLabel = MarkerWithLabelFactory.initMarkerWithLabel(window.google);

		this.activate();
		this.initHandlers();
	}

	initHandlers() {
		var events = ['mouseover', 'mouseout', 'gmp-click'];
		for (var i in events) {
			var ev = events[i];
			this.googleMaps.event.addListener(
				this.marker,
				ev,
				$.proxy(this.publishEvent, this, ev, this.id)
			);
		}
	}

	zoomChanged() {
		this.destroy();
		this.marker = this.createMarker();
		this.marker.setVisible(true);
		this.initHandlers();
	}
	
	setIcon(icon) {

		this.marker.setIcon(icon);
	}

	setActiveIcon() {

		if (this.marker.labelClass !== this.labelClassSelected) {
			this.marker.labelClass = this.labelClassSelected;
		}
	}

	setDetailIcon() {

		if (this.marker.labelClass !== this.labelClassDetail) {
			this.marker.labelClass = this.labelClassDetail;
		}
	}

	setHoverIcon() {

		if (this.marker.labelClass !== this.labelClassHovered) {
			this.marker.labelClass = this.labelClassHovered;
		}
	}

	setDefaultIcon() {

		if (this.marker.labelClass !== this.labelClass) {
			this.marker.labelClass = this.labelClass;
		}
	}

	setLabelClasses({inDetailMode, isHovered}) {

		var label = this.labelClass;
		if (inDetailMode && this.isMarketplaceSeller && this.isMpsProduct) {
			label += " " + labelClassDetailMps;
		} else if (inDetailMode && !this.isMarketplaceSeller) {
            label += " " + labelClassDetail;
		}
		
		if (isHovered && this.isMarketplaceSeller && this.isMpsProduct) {
			label += " " + labelClassHoverMps;
		} else if(isHovered && !this.isMarketplaceSeller) {
            label += " " + labelClassHover;
		}
		
		this.marker.labelClass = label;
		this.marker.labelDiv.className = label;
	}

	getGoogleMarker() {

		return this.marker;
	}

	publishEvent(event) {
		this.notify(event, this.id);
	}

	loadDependenices() {

		if (!window.google.maps) {
			return false;
		}

		this.googleMaps = window.google.maps;

		return true;
	}

	activate() {

		if (!this.marker) {
			this.marker = this.createMarker();

			if (this.stationData.sponsored && this.stationData.totalPrice.indexOf('loading') === -1) {
				this.googleMaps.event.addListener(this.map, 'zoom_changed', this.zoomChanged.bind(this));
			}
		}

		this.marker.setVisible(true);

		return true;
	}

	formatLocation(latitude, longitude) {

		return new this.googleMaps.LatLng(latitude, longitude);
	}

	getLocation() {

		return this.location;
	}

	initLocation() {

		this.location = this.formatLocation(this.latitude, this.longitude);
	}

	createMarker() {
		var labelContent;
		var value;

		this.initLocation();

		if (this.value === "N/A") {
			return new this.googleMaps.marker.AdvancedMarkerElement({
				position: this.location,
				map: this.map,
				icon: this.icons.fallback
			});
		}

		if (this.value.match(/loading-small/)) {
			value = 'Calculating...';
		} else if (this.value.match(/(free-fitting|From:)/)) {
			value = this.value;
		} else {
			value = this.value.replace(/ /g,'');
		}

		if (this.stationData && this.stationData.sponsored) {
			labelContent = `
				<div class="sponsored-fitting-label">
					<div>
						<style>
							.fitting-label:has(.sponsored-fitting-label):after, .fitting-label--hovered:has(.sponsored-fitting-label):after{border-top: 10px solid ${this.stationData.primaryColor};}
							.fitting-label:has(.sponsored-fitting-label):hover, .fitting-label--hovered:has(.sponsored-fitting-label) {border: 2px solid ${this.stationData.secondaryColor};}
							.fitting-label:has(.sponsored-fitting-label):hover:after, .fitting-label--hovered:has(.sponsored-fitting-label):after {border-top: 10px solid ${this.stationData.secondaryColor}; bottom: -10px;}
							</style>
						<img alt="" src="${this.stationData.mapMarkerImage}" style="width:${this.map.zoom > 12 ? '75px' : '50px'};">
					</div>
					<div style="text-align: center;">
						<p class='fitting-label__station-mobile-fitter-hint'>
							${value}
						</p>
					</div>
				</div>
			`;
		} else if (this.stationName && this.isMobileFitter) {
			labelContent = `
				<div>
					<p class='fitting-label__station-price'>
            			<img alt="" src="${truckIcon}" style="width:32px;">${value}</p>
					<p class='fitting-label__station-mobile-fitter-hint'>
						Mobile Fitter
					</p>
				</div>
			`;
		} else if (this.stationName) {
			labelContent = `
				<div>
					<p class='fitting-label__station-name'>${this.stationName}</p>
					<p class='fitting-label__station-price'>${value}</p>
				</div>
			`;
		} else {
			labelContent = value;
		}

		return new this.markerWithLabel({
			position: this.location,
			map: this.map,
			icon: this.icons.initial,
			draggable: false,
			raiseOnDrag: false,
			labelContent: labelContent,
			labelAnchor: new this.googleMaps.Point(20, 30),
			labelClass: this.labelClass, // the CSS class for the label
			labelInBackground: true,
			style: this.labelStyle,
		});
	}

	deactivate() {

		this.marker.setVisible(false);
	}

	destroy() {

		this.marker.setVisible(null);
	}
}

export default MapMarker;